import PRPD from './PRPD.js'
import SPDG from './SPDG.js'
import SPDH from './SPDH.js'
import ILPF from './ILPF.js'
import SAF from './SAF.js'
import FP from './FP.js'
import MRPA from './MRPA.js'
import TI from './TI.js'

const modelsPraticas = {
  PRPD,
  SPDG,
  SPDH,
  ILPF,
  SAF,
  FP,
  MRPA,
  TI
}

export default modelsPraticas



// WEBPACK FOOTER //
// ./src/libs/models/cadastro/praticas/index.js